export const tiposTelefone = {
	PESSOAL: 0,
	TRABALHO: 1,
	OUTROS: 2,
	WHATSAPP: 3,
}
